(() => {
  const body = document.body;
  const main = document.getElementById('main-content');
  const drawers = Array.from(document.querySelectorAll('.side-panel, #mobile-menu'));

  if (!main && !drawers.length) return;

  const FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), summary, details';

  const focusables = (root) =>
    Array.from(root.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null && !el.hasAttribute('inert'));

  const triggerByDrawer = new WeakMap();
  const inertedByDrawer = new WeakMap();
  let activeDrawer = null;

  const findActive = () => drawers.find((d) => d.classList.contains('active')) || null;

  const collectInertTargets = (drawer) => {
    const targets = new Set();
    drawers.forEach((d) => {
      if (d !== drawer) targets.add(d);
    });

    if (main && !main.contains(drawer)) {
      targets.add(main);
    } else if (main && main.contains(drawer)) {
      let node = drawer;
      while (node && node !== body) {
        const parent = node.parentElement;
        if (!parent) break;
        Array.from(parent.children).forEach((sibling) => {
          if (sibling !== node && !sibling.contains(drawer)) {
            targets.add(sibling);
          }
        });
        if (parent === body) break;
        node = parent;
      }
    }

    return Array.from(targets);
  };

  const moveFocusIn = (drawer) => {
    const items = focusables(drawer);
    const target = items[0] || drawer;
    if (target && typeof target.focus === 'function') target.focus();
  };

  const restoreFocus = (drawer) => {
    const trigger = triggerByDrawer.get(drawer);
    if (trigger && typeof trigger.focus === 'function') trigger.focus();
    triggerByDrawer.delete(drawer);
  };

  const clearInert = () => {
    if (activeDrawer) {
      const previous = inertedByDrawer.get(activeDrawer) || [];
      previous.forEach((el) => el.removeAttribute('inert'));
      inertedByDrawer.delete(activeDrawer);
    }
    if (main) main.removeAttribute('inert');
    drawers.forEach((d) => {
      d.removeAttribute('inert');
      d.removeAttribute('aria-modal');
    });
  };

  const updateInert = () => {
    const next = findActive();

    if (next && next !== activeDrawer) {
      triggerByDrawer.set(next, document.activeElement);
      const targets = collectInertTargets(next);
      targets.forEach((el) => {
        el.setAttribute('inert', '');
        if (drawers.includes(el)) el.removeAttribute('aria-modal');
      });
      inertedByDrawer.set(next, targets);
      next.setAttribute('aria-modal', 'true');
      next.removeAttribute('inert');
      activeDrawer = next;
      requestAnimationFrame(() => moveFocusIn(next));
    } else if (!next && activeDrawer) {
      clearInert();
      const closed = activeDrawer;
      activeDrawer = null;
      requestAnimationFrame(() => restoreFocus(closed));
    } else if (!next) {
      clearInert();
    }
  };

  const bodyObserver = new MutationObserver(updateInert);
  bodyObserver.observe(body, { attributes: true, attributeFilter: ['class'] });

  drawers.forEach((d) => {
    const drawerObserver = new MutationObserver(updateInert);
    drawerObserver.observe(d, { attributes: true, attributeFilter: ['class'] });
  });

  document.addEventListener('keydown', (e) => {
    const open = findActive();
    if (!open) return;

    if (e.key === 'Escape') {
      const closeBtn = open.querySelector('side-panel-close, .side-panel-close, .mobile-menu-close, [data-drawer-close]');
      if (closeBtn && typeof closeBtn.click === 'function') {
        closeBtn.click();
      } else if (open.id === 'mobile-menu') {
        body.classList.remove('open-mobile-menu', 'menu_open');
        open.classList.remove('active');
      }
      return;
    }

    if (e.key !== 'Tab') return;

    const items = focusables(open);
    if (items.length === 0) {
      e.preventDefault();
      return;
    }
    const first = items[0];
    const last = items[items.length - 1];
    const current = document.activeElement;

    if (!open.contains(current)) {
      e.preventDefault();
      first.focus();
      return;
    }

    if (e.shiftKey && current === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && current === last) {
      e.preventDefault();
      first.focus();
    }
  });

  updateInert();
})();
